import * as React from "react";
import * as ReactDOM from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { flushQueue } from "./helper/quotationQueue";
import App from "./App";
import theme from "./theme";
import "./styles/style.css";
import "bootstrap/dist/css/bootstrap.min.css";


declare const window: any;

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement!);

if (window.hybrid) {
  // Evento normal de navegadores
  window.addEventListener("online", () => {
    console.log("🌐 Internet disponible, enviando cotizaciones en cola...");
    flushQueue();
  });

  // Intervalo de respaldo: cada 15 segundos intenta enviar si hay internet
  setInterval(() => {
    if (navigator.onLine) {
      flushQueue();
    }
  }, 15000);
}

root.render(
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <App />
  </ThemeProvider>
);
